import { Injectable } from '@angular/core';
import { ModalService } from '@epicuro-next/ataraxia/modal';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap, take } from 'rxjs/operators';

import { modalActionGroup } from '../actions/modal-actions';

@Injectable()
export class ModalEffectsService {
  constructor(
    private readonly actions$: Actions,
    private readonly modalService: ModalService,
  ) {}

  public show$ = createEffect(() =>
    this.actions$.pipe(
      ofType(modalActionGroup.show),
      mergeMap((action) => {
        const modal = this.modalService.openGenericModal(
          action.choices,
          action.noAnswerValue,
          action.message,
          action.title,
        );

        return modal.result.pipe(
          take(1),
          map((answer) => {
            return modalActionGroup.answer({
              answer,
            });
          }),
        );
      }),
    ),
  );
}
